export const colorPalette: string[] = [
    // Row 1
    '#ffffff',
    '#ffccff',
    '#ff99ff',
    '#ff66ff',
    '#ff33ff',
    '#ff00ff',
    '#ccffff',
    '#ccccff',
    '#cc99ff',
    '#cc66ff',
    '#cc33ff',
    '#cc00ff',
    '#99ffff',
    '#99ccff',
    '#9999ff',
    '#9966ff',
    '#9933ff',
    '#9900ff',
    // Row 2
    '#ffffcc',
    '#ffcccc',
    '#ff99cc',
    '#ff66cc',
    '#ff33cc',
    '#ff00cc',
    '#ccffcc',
    '#cccccc',
    '#cc99cc',
    '#cc66cc',
    '#cc33cc',
    '#cc00cc',
    '#99ffcc',
    '#99cccc',
    '#9999cc',
    '#9966cc',
    '#9933cc',
    '#9900cc',
    // Row 3
    '#ffff99',
    '#ffcc99',
    '#ff9999',
    '#ff6699',
    '#ff3399',
    '#ff0099',
    '#ccff99',
    '#cccc99',
    '#cc9999',
    '#cc6699',
    '#cc3399',
    '#cc0099',
    '#99ff99',
    '#99cc99',
    '#999999',
    '#996699',
    '#993399',
    '#990099',
    // Row 4
    '#ffff66',
    '#ffcc66',
    '#ff9966',
    '#ff6666',
    '#ff3366',
    '#ff0066',
    '#ccff66',
    '#cccc66',
    '#cc9966',
    '#cc6666',
    '#cc3366',
    '#cc0066',
    '#99ff66',
    '#99cc66',
    '#999966',
    '#996666',
    '#993366',
    '#990066',
    // Row 5
    '#ffff33',
    '#ffcc33',
    '#ff9933',
    '#ff6633',
    '#ff3333',
    '#ff0033',
    '#ccff33',
    '#cccc33',
    '#cc9933',
    '#cc6633',
    '#cc3333',
    '#cc0033',
    '#99ff33',
    '#99cc33',
    '#999933',
    '#996633',
    '#993333',
    '#990033',
    // Row 6
    '#ffff00',
    '#ffcc00',
    '#ff9900',
    '#ff6600',
    '#ff3300',
    '#ff0000',
    '#ccff00',
    '#cccc00',
    '#cc9900',
    '#cc6600',
    '#cc3300',
    '#cc0000',
    '#99ff00',
    '#99cc00',
    '#999900',
    '#996600',
    '#993300',
    '#990000',
    // Row 7
    '#66ffff',
    '#66ccff',
    '#6699ff',
    '#6666ff',
    '#6633ff',
    '#6600ff',
    '#33ffff',
    '#33ccff',
    '#3399ff',
    '#3366ff',
    '#3333ff',
    '#3300ff',
    '#00ffff',
    '#00ccff',
    '#0099ff',
    '#0066ff',
    '#0033ff',
    '#0000ff',
    // Row 8
    '#66ffcc',
    '#66cccc',
    '#6699cc',
    '#6666cc',
    '#6633cc',
    '#6600cc',
    '#33ffcc',
    '#33cccc',
    '#3399cc',
    '#3366cc',
    '#3333cc',
    '#3300cc',
    '#00ffcc',
    '#00cccc',
    '#0099cc',
    '#0066cc',
    '#0033cc',
    '#0000cc',
    // Row 9
    '#66ff99',
    '#66cc99',
    '#669999',
    '#666699',
    '#663399',
    '#660099',
    '#33ff99',
    '#33cc99',
    '#339999',
    '#336699',
    '#333399',
    '#330099',
    '#00ff99',
    '#00cc99',
    '#009999',
    '#006699',
    '#003399',
    '#000099',
    // Row 10
    '#66ff66',
    '#66cc66',
    '#669966',
    '#666666',
    '#663366',
    '#660066',
    '#33ff66',
    '#33cc66',
    '#339966',
    '#336666',
    '#333366',
    '#330066',
    '#00ff66',
    '#00cc66',
    '#009966',
    '#006666',
    '#003366',
    '#000066',
    // Row 11
    '#66ff33',
    '#66cc33',
    '#669933',
    '#666633',
    '#663333',
    '#660033',
    '#33ff33',
    '#33cc33',
    '#339933',
    '#336633',
    '#333333',
    '#330033',
    '#00ff33',
    '#00cc33',
    '#009933',
    '#006633',
    '#003333',
    '#000033',
    // Row 12
    '#66ff00',
    '#66cc00',
    '#669900',
    '#666600',
    '#663300',
    '#660000',
    '#33ff00',
    '#33cc00',
    '#339900',
    '#336600',
    '#333300',
    '#330000',
    '#00ff00',
    '#00cc00',
    '#009900',
    '#006600',
    '#003300',
    '#000000'
  ];